import { FC, useEffect } from "react";
import {
  CheckAuthentication,
  UpdateUserLastActionDate,
} from "../../helper/ui/methods";
import { useAppStateContext } from "../../middleware/context/state-context-provider";
import MainNavigationPanel from "../ui/user/main-navigation-panel";
import MainFooterPanel from "../ui/user/main-footer-panel";
import { useNavigate } from "react-router-dom";
import "../../styles/pricing-page.css";

export const Pricing: FC = () => {
  const [state, dispatch] = useAppStateContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.user === null || state.user === undefined) {
      CheckAuthentication(dispatch);
    }
  }, []);

  useEffect(() => {
    if (state.user) {
      UpdateUserLastActionDate(state.user, dispatch);
    }
  }, [state.user]);

  /* the trial is where everyone starts, so the same action serves both
     plans: the dashboard for a signed-in user, registration for everyone
     else */
  const StartTrial = () => {
    if (state.user) {
      navigate("/dashboard");
    } else {
      navigate("/authentication&registration");
    }
  };

  return (
    <>
      {(() => {
        return (
          <div
            id="pageWrapper"
            onClick={
              state.user
                ? () => UpdateUserLastActionDate(state.user!, dispatch)
                : undefined
            }
          >
            <MainNavigationPanel user={state.user} />
            <div id="contentWrapper">
              <div id="content" className="pageSurface">
                <div id="informationCanvas">
                  <span className="pageEyebrow">Pricing</span>
                  <h1>One plan, priced per seat</h1>
                  <p>
                    Every seat carries the same Digital Charcoal: the cloud
                    ecosystem, the viewers, and the plugins that feed them.
                    There is no tier to outgrow and no feature held back — the
                    only choice is how often you would like to be billed.
                  </p>

                  <div id="pricingPlans">
                    <div className="plan">
                      <div className="planHeading">
                        <span className="planName">Monthly</span>
                      </div>
                      <div className="planPrice">
                        <span className="planPriceAmount">$50</span>
                        <span className="planPriceUnit">per seat / month</span>
                      </div>
                      <p>
                        Billed every month. Add seats as the team grows and
                        drop them again when a project closes.
                      </p>
                      <span className="pageAction" onClick={StartTrial}>
                        Start the 30-day trial
                      </span>
                    </div>
                    <div className="plan planFeatured">
                      <div className="planHeading">
                        <span className="planName">Yearly</span>
                        <span className="planTag">Two months free</span>
                      </div>
                      <div className="planPrice">
                        <span className="planPriceAmount">$500</span>
                        <span className="planPriceUnit">per seat / year</span>
                      </div>
                      <p>
                        Billed once a year at the price of ten months, which
                        saves $100 on every seat you keep for the year.
                      </p>
                      <span
                        className="pageAction pageActionPrimary"
                        onClick={StartTrial}
                      >
                        Start the 30-day trial
                      </span>
                    </div>
                  </div>

                  <h3>Every seat includes</h3>
                  <ul className="planIncludes">
                    <li>
                      Cloud projects with folders, file versions, and sharing
                      across your team.
                    </li>
                    <li>
                      The standard, 4D, and map viewers, in the browser and
                      with nothing to install.
                    </li>
                    <li>
                      The report viewer, for reading and annotating the reports
                      your team publishes.
                    </li>
                    <li>
                      ForgeLine, our Navisworks plugin, with its Charvue and
                      Charsync features, and the upgrades that follow it.
                    </li>
                  </ul>

                  <h3>The 30-day trial</h3>
                  <p>
                    Every account opens on a 30-day trial of the full product.
                    No card is asked for up front, and nothing is charged until
                    you pick a plan at the end of it. If you leave the trial
                    where it is, the account simply stops at day thirty and your
                    data stays where you put it.
                  </p>

                  <h3>Larger teams</h3>
                  <p>
                    If you are buying for a whole coordination team, or need a
                    purchase order, an invoice, or an on-premises deployment
                    rather than our cloud, we would rather talk it through than
                    have you guess from a table.
                  </p>
                  <div className="pageActionWrapper">
                    <span
                      className="pageAction"
                      onClick={() => {
                        navigate("/contact_us");
                      }}
                    >
                      Contact us
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <MainFooterPanel />
          </div>
        );
      })()}
    </>
  );
};
